import { Injectable } from '@angular/core';
import {Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions} from '@angular/http';

import { API_ENDPOINTS } from '../../shared/configuration/api-endpoints';

import { StorageService } from '../../shared/services/storage.service';
import { ErrorService } from '../../shared/services/error.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { EncryptionService } from '../../shared/services/encryption.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';

@Injectable()
export class ProfileService{

    vChangePasswordData: {
		previous_password: string,
        proposed_password: string,
        retype_proposed_password: string
	};

    vChangeSecurityData: {
		old_security_question: string,
        old_security_answer: string,
        new_security_question: string,
        new_security_answer: string,
	};

    vProfileData : {
        email: string,
        first_name: string,
        last_name: string,
        company_reg_no: string,
        phone_no: string,
        company_name: string,
        designation: string,
        address_line_1: string,
        address_line_2: string,
        building_name: string,
        postal_code: string,
        licence_id: string,
        registration_type: string
    }

    vLoadingStatus: boolean;

    constructor(
        private _http: Http,
        private _errorService: ErrorService,
        private _storageService: StorageService,
        private _encryptionService: EncryptionService,
        private _popupService: PopupService,
        private _pageNavigationService: PageNavigationService,
    ) {
        this.vLoadingStatus = false;
    }

    getChangePasswordData(){
        return this.vChangePasswordData;
    }

    getChangeSecurityData(){
        return this.vChangeSecurityData;
    }

    getUserProfileData(){
        return this.vProfileData;
    }

    isLoading(){
        return this.vLoadingStatus;
    }

    resetChangePasswordData(){
        this.vChangePasswordData = {
            previous_password: '',
            proposed_password: '',
            retype_proposed_password: ''
        }
    }

    resetChangeSecurityData(){
        this.vChangeSecurityData = {
            old_security_question: '',
            old_security_answer: '',
            new_security_question: '',
            new_security_answer: '',
        }
    }

    resetProfileData(){
        this.vProfileData = {
            email: '',
            first_name: '',
            last_name: '',
            company_reg_no: '',
            phone_no: '',
            company_name: '',
            designation: '',
            address_line_1: '',
            address_line_2: '',
            building_name: '',
            postal_code: '',
            licence_id: '',
            registration_type: ''
        }
    }

    resetError() {
        this._errorService.resetErrorFlag();
        this._errorService.resetError();
        this._errorService.resetBackEndError();
    }

    isDisableChangePassword(){
        if(this.vChangePasswordData.previous_password.trim() === undefined || this.vChangePasswordData.previous_password.trim() === ''){
            return true;
        } else if(this.vChangePasswordData.proposed_password.trim() === undefined || this.vChangePasswordData.proposed_password.trim() === ''){
            return true;
        } else if(this.vChangePasswordData.retype_proposed_password.trim() === undefined || this.vChangePasswordData.retype_proposed_password.trim() === ''){
            return true;
        } else if(this.vChangePasswordData.previous_password.trim().length < 8){
            return true;
        }else if(this.vChangePasswordData.proposed_password.trim().length < 8){
            return true;
        }
        return false;
    }

    isDisableChangeSecurity(){
        return (this.vChangeSecurityData.old_security_question.trim() === undefined || this.vChangeSecurityData.old_security_question.trim() === ''
            || this.vChangeSecurityData.old_security_answer.trim() === undefined || this.vChangeSecurityData.old_security_answer.trim() === ''
            || this.vChangeSecurityData.new_security_question.trim() === undefined || this.vChangeSecurityData.new_security_question.trim() === ''
            || this.vChangeSecurityData.new_security_answer.trim() === undefined || this.vChangeSecurityData.new_security_answer.trim() === '') ? true: false;
    }

    isDisableUpdateProfile(){

        if (this.vProfileData.registration_type === 'C'||this.vProfileData.registration_type === ''||this.vProfileData.registration_type === undefined)
        {
            if(this.vProfileData.first_name.trim() === undefined || this.vProfileData.first_name.trim() === ''){
                return true;
            } else if(this.vProfileData.last_name.trim() === undefined || this.vProfileData.last_name.trim() === ''){
                return true;
            } else if(this.vProfileData.company_reg_no.trim() === undefined || this.vProfileData.company_reg_no.trim() === ''){
                return true;
            } else if(this.vProfileData.phone_no.trim() === undefined || this.vProfileData.phone_no.trim() === ''){
                return true;
            }else if(this.vProfileData.company_name.trim() === undefined || this.vProfileData.company_name.trim() === ''){
                return true;
            } else if(this.vProfileData.designation.trim() === undefined || this.vProfileData.designation.trim() === ''){
                return true;
            } else if(this.vProfileData.address_line_1.trim() === undefined || this.vProfileData.address_line_1.trim() === ''){
                return true;
            } else if(this.vProfileData.postal_code.trim() === undefined || this.vProfileData.postal_code.trim() === ''){
                return true;
            }
            return false;
        }
        else if (this.vProfileData.registration_type === 'F')
        {
            if(this.vProfileData.first_name.trim() === undefined || this.vProfileData.first_name.trim() === ''){
                return true;
            } else if(this.vProfileData.last_name.trim() === undefined || this.vProfileData.last_name.trim() === ''){
                return true;
            } else if(this.vProfileData.phone_no.trim() === undefined || this.vProfileData.phone_no.trim() === ''){
                return true;
            } else if(this.vProfileData.licence_id.trim() === undefined || this.vProfileData.licence_id.trim() === ''){
                return true;
            } else if(this.vProfileData.address_line_1.trim() === undefined || this.vProfileData.address_line_1.trim() === ''){
                return true;
            } else if(this.vProfileData.postal_code.trim() === undefined || this.vProfileData.postal_code.trim() === ''){
                return true;
            }
            return false;
        }
       
    }

    changePassword() {
        this.resetError();

        if(this.vChangePasswordData.proposed_password !== this.vChangePasswordData.retype_proposed_password){
            this._errorService.setErrorFlag(true);
            //this._errorService.setErrorStatusAndMessage('retypePassword', 'The password are not match');
            this._errorService.setErrorStatusAndMessage('retypePassword', 'The new password and confirm new password does not match.');
            return;
        }

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.ACCOUNT.CHANGE_PASSWORD, this.vChangePasswordData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                console.log(response);
                this._popupService.closePopup();
                this._popupService.openGeneralConfirmationPopup('Notice', 'You have successfully changed your password. You may now access the portal with your new password. Thank You.', '', true, false);
                this.resetChangePasswordData();
            },
            (error)  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                if(vErrorData.code === 906){
                    this._popupService.closePopup();
                    this._popupService.openGeneralConfirmationPopup('Notice', 'The old password entered is incorrect.', '', false, true);
                } else if(vErrorData.code === 908){
                    this._popupService.closePopup();
                    this._popupService.openGeneralConfirmationPopup('Notice', 'Attempt limit exceeded, please try again after some time', '', false, false);
                }else if(vErrorData.code === 810){
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                } else {
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
                this.resetChangePasswordData();
            }
        );
        this.resetError();
    }

    changeSecurity() {
        this.resetError();
        this.vLoadingStatus = true;

        var promise = this._http.post(API_ENDPOINTS.ACCOUNT.CHANGE_SECURITY_QUESTION, this.vChangeSecurityData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                this._popupService.closePopup();
                this._popupService.openGeneralConfirmationPopup('Notice', 'You have successfully update your security question. Thank You.', '', true, false);
                this.resetChangeSecurityData();
                this.loadUserProfile();
            },
            (error)  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                if(vErrorData.code === 51015){
                    this._popupService.closePopup();
                    this._popupService.openGeneralConfirmationPopup('Notice', 'The old security question’s answer provided does not match with our record.', '', false, true);
                } else {
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
                this.vChangeSecurityData.new_security_question = ''
                this.vChangeSecurityData.new_security_answer = '';
                this.vChangeSecurityData.old_security_answer = ''
            }
        );
        this.resetError();
    }

    loadUserProfile(){
        this.vLoadingStatus = true;
        this._http.get(API_ENDPOINTS.ACCOUNT.USER_PROFILE).subscribe( 
        (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);

                this.vProfileData = vResponseData.data.user;
                this.vChangeSecurityData.old_security_question = vResponseData.data.user.security_question;
            },

            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    validateUpdateUserProfile(){
        /*if( !/^\+?\d+$/.test(this.vProfileData.phone_no)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('phoneNo', 'Phone number provided is not valid');
        }
        if(!/^[0-9]+$/.test(this.vProfileData.postal_code)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('postalCode', 'Postal code provided is not valid');
        }*/
        //Anjaiah
        if(!/^[6|8|9][0-9]{7}$/.test(this.vProfileData.phone_no)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('phoneNo', 'The phone no. format is invalid');
        }
        if(!/^[0-9]+$/.test(this.vProfileData.postal_code)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('postalCode', 'The postal code is invalid.');
        }
        if(this.vProfileData.postal_code.length!=6){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('postalCode', 'The postal code format is invalid.');
        }
    }

    updateUserProfile(){
        this.resetError();
        this.validateUpdateUserProfile();

        if(this._errorService.getErrorFlag()){
            this._popupService.openGeneralConfirmationPopup('Notice', 'Some of the required information is invalid or missing. Please correct them before proceeding with the profile update. Thank You.', '', false, false);
            return;
        }

        var xData = {
            first_name: this.vProfileData.first_name,
            last_name: this.vProfileData.last_name,
            company_reg_no: this.vProfileData.company_reg_no,
            phone_no: this.vProfileData.phone_no,
            company_name: this.vProfileData.company_name,
            designation: this.vProfileData.designation,
            address_line_1: this.vProfileData.address_line_1,
            address_line_2: this.vProfileData.address_line_2,
            postal_code: this.vProfileData.postal_code,
            building_name: this.vProfileData.building_name,
            licence_id: this.vProfileData.licence_id
        }

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.ACCOUNT.UPDATE_USER_PROFILE, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                
                let data = this._storageService.getLocalItem('personalData');
                let parsedData;
                
                if(data !== null){
                    parsedData = JSON.parse(data);
                }

                let vPersonalData = {
                    userid: parsedData.userid,
                    name: this.vProfileData.first_name,
                    username: parsedData.username,
                    companyname: parsedData.company_name,
                    licenseid: parsedData.licence_id

                }
                var strPersonalData = JSON.stringify(vPersonalData);
                this._storageService.setLocalItem('personalData', strPersonalData);

                this._popupService.openGeneralConfirmationPopup('Notice', 'Your profile has been updated. Thank You.', '', true, false);
                this.loadUserProfile();//Kowsalya
            },

            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc)
            }
        );
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/profile/services/profile.service.ts